import { render, staticRenderFns } from "./ServiceOrderTop5Month.vue?vue&type=template&id=12b747c2&scoped=true&"
import script from "./ServiceOrderTop5Month.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderTop5Month.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b747c2",
  null
  
)

export default component.exports